const VisualComponent = require('../../axel-publication-content/js/VisualComponent');
const Utils = require('./crossmarkUtils');
class CrossmarkBadge extends VisualComponent {
    endpoint = 'https://crossmark.crossref.org/dialog';
    scriptVersion = 'v2.0';
    stylesheetUrl = 'https://crossmark-cdn.crossref.org/widget/v2.0/style.css';

    constructor(articleView, renderDialog) {
        super(articleView);
        this.renderDialog = renderDialog;
        this.articleView = articleView;
        this.crossmarkLinks = document.querySelectorAll('[data-target=crossmark]');
    }

    initiate() {
        if (this.crossmarkLinks.length === 0) return;

        let queryData = this.buildQuery();
        let queryString = Utils.buildQueryString(queryData);
        let fullLink = `${this.endpoint}${queryString}`;
        let stylesheetLink = Utils.buildLinkElement(this.stylesheetUrl);
        document.querySelector('head').appendChild(stylesheetLink);
        this.buildDialog(fullLink, Utils.isIos());
        this.bindLinksToUrl();
        this.bindDialogClose();
        this.main.querySelector('.crossmark-popup__inner').addEventListener('click', event => {
            event.stopPropagation();
        });
    }

    buildDialog(iframeSrc, isIos) {
        this.main = document.createElement('div');
        this.main.innerHTML = this.renderDialog({
            query: iframeSrc,
            isIos,
        });
        this.main.setAttribute('id', 'crossmark-widget');
        this.hide();
        document.body.appendChild(this.main);
    }

    bindDialogClose() {
        this.main.querySelectorAll('.crossmark-overlay, .crossmark-popup, .crossmark-popup__btn-close').forEach(elm => {
            elm.addEventListener('click', event => {
                this.hide();
                event.preventDefault();
                event.stopPropagation();
            });
        });
    }

    buildQuery() {
        return {
            doi: this.crossmarkLinks[0].dataset.doi,
            domain: window.location.hostname,
            uri_scheme: window.location.protocol,
            cm_version: this.scriptVersion,
        };
    }

    bindLinksToUrl() {
        this.crossmarkLinks.forEach(link => {
            link.style.cursor = 'pointer';
            link.addEventListener('click', e => {
                e.preventDefault();
                this.show(link);
                if (Utils.isIos()) {
                    this.main.querySelector('.crossmark-popup__inner').style.top = `${window.scrollY}px`;
                }
            });
        });
    }
    show(crossmarkButton) {
        if (this.main) {
            this.main.style.display = 'block';
            this.articleView.escapeModals.push(() => this.hide());
            this.articleView.focusTrap?.init(
                'crossmark',
                document.querySelector('.crossmark-popup__inner'),
                {
                    fallbackFocus: document.querySelector('.core-collateral'),
                    initialFocus: this.main.querySelector('button'),
                    setReturnFocus: crossmarkButton,
                },
                true
            );
        }
    }
    hide() {
        if (this.main) {
            this.main.style.display = 'none';
            this.articleView.escapeModals.pop();
            this.articleView.focusTrap?.deactivate();
        }
    }
}

module.exports = CrossmarkBadge;
